<search-box
  #box
  [placeHolder]="placeHolder"
  buttonText=""
  [searchCriteria]="model"
  (searchCriteriaChanged)="search($event)"
  (showFilters)="showPicker.emit('')"
  [options]="{required:true}"
>
</search-box>
